import { render } from "./A4Landscape.vue?vue&type=template&id=6369f676&scoped=true"
const script = {}

import "./A4Landscape.vue?vue&type=style&index=0&id=6369f676&scoped=true&lang=css"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6369f676"]])

export default __exports__